import { gql } from "lib/apolloClient";

const assessmentFragment = gql`
  fragment assessmentItem on Assessment {
    id
    type
    isImported
    title {
      id
      value
    }
    academicTerm {
      id
      lockingStatus
    }
    assessmentType {
      id
      value
    }
    taskType {
      id
      type
      label
      color
      displaySequence
      metaData
    }
    image {
      id
      value
    }
    category {
      id
      label
    }
  }
`;

const attachmentFragment = gql`
  fragment attachmentItem on Attachment {
    id
    attachmentType: type
    attachmentTitle: title
    name
    mimeType
    url
    signedUrl
    thumbUrl
    __typename
  }
`;

const childrenHierarchyInfoFragment = gql`
  fragment childrenHierarchyInfo on EntityFlowResource {
    childrenHierarchyInfo(filters: $filters) {
      maxDepth
      totalCount
      totalCountWithFolder
    }
  }
`;

const unitFlowItem = gql`
  fragment unitFlowItem on EntityFlowResource {
    id
    label
    displaySequence
    isRepeated
    repeatedResources
    depth
    resourceType: itemType
    item {
      ... on Assessment {
        ...assessmentItem
      }
      ... on Attachment {
        ...attachmentItem
      }
      ... on EntityFlowResource {
        id
        attachment {
          ...attachmentItem
        }
      }
    }
    parent {
      id
    }
  }
  ${assessmentFragment}
  ${attachmentFragment}
`;

const unitFlowItemWithoutDepth = gql`
  fragment unitFlowItem on EntityFlowResource {
    id
    label
    displaySequence
    isRepeated
    repeatedResources
    resourceType: itemType
    item {
      ... on Assessment {
        ...assessmentItem
      }
      ... on Attachment {
        ...attachmentItem
      }
      ... on EntityFlowResource {
        id
        attachment {
          ...attachmentItem
        }
      }
    }
    parent {
      id
    }
  }
  ${assessmentFragment}
  ${attachmentFragment}
`;

export const unitFlowFragment = {
  unitFlowItem,
  unitFlowWithChildren: gql`
    fragment unitFlowWithChildrenItem on EntityFlowResource {
      ...unitFlowItem
      childrenV2: children(filters: $filters) {
        id
        label
        resourceType: itemType
        displaySequence
      }
      ...childrenHierarchyInfo
    }
    ${unitFlowItem}
    ${childrenHierarchyInfoFragment}
  `,
  childrenHierarchyInfoFragment,
};

export const unitFlowFragmentWithoutDepth = {
  unitFlowWithChildren: gql`
    fragment unitFlowWithChildrenItem on EntityFlowResource {
      ...unitFlowItem
      childrenV2: children(filters: $filters) {
        id
        label
        resourceType: itemType
        displaySequence
      }
      ...childrenHierarchyInfo
    }
    ${unitFlowItemWithoutDepth}
    ${childrenHierarchyInfoFragment}
  `,
};

export const unitFlowOutlineFragment = {
  unitFlowOutlineItem: gql`
    fragment unitFlowOutlineItem on EntityFlowResource {
      childrenV2: children(filters: $filters) {
        id
      }
      parent {
        id
      }
    }
  `,
};

export const unitResourceFragment = gql`
  fragment unitResourceItem on EntityFlowResource {
    id
    label
    resourceType: itemType
    attachment {
      id
      type
      title
      name
      mimeType
      url
      signedUrl
      thumbUrl
      __typename
    }
  }
`;
